module.exports = __webpack_public_path__ + "static/media/2manage.b170dac7.svg";